import React from 'react';
import { format } from 'date-fns';
import * as PropTypes from 'prop-types';

import {
  Date,
  NoteInfo,
  NoteWrap,
  MeetingNote,
  CreatorName,
  CreatorDataWrap,
  ParticipantsWrap,
  RatePannelWrapper,
  MeetingInfoWrapper,
  ReactQuillWrappedContainer,
} from './styles';

import {
  DropdownItem,
  DropdownList,
  DropdownAction,
  DropdownContent,
} from '../../ui-helpers';

import { SvgIcon } from '../../svg-icon';
import { MeetingInfo } from './meeting-info';
import { RatePannel } from '../../rate-pannel';
import { ReactQuillWrapped } from '../../react-quill';
import { DropdownWithDots, Popconfirm } from '../../popovers';
import { getMeetingAverageRating, stripHtml } from '../../../utils';
import { ParticipantsWithFeedbacks } from './meeting-participants-feedbacks';

const DATE_FORMAT = 'HH:mm d MMM yyyy';

const Creator = ({ fullName, date }) => (
  <CreatorDataWrap>
    <CreatorName>{fullName}</CreatorName>
    <Date>{format(date, DATE_FORMAT)}</Date>
  </CreatorDataWrap>
);

Creator.propTypes = {
  fullName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};


const NoteControl = ({
  _id,
  requestId,
  openNoteModal,
  handleNoteDelete,
}) => (
  <DropdownContent>
    <DropdownList>
      <DropdownItem>
        <DropdownAction onClick={() => openNoteModal(requestId, _id)}>
          <SvgIcon type="pencil" />
          Update
        </DropdownAction>
      </DropdownItem>
      <DropdownItem>
        <Popconfirm
          title="Are you sure delete this meeting note?"
          onConfirm={() => handleNoteDelete(_id)}
        >
          <DropdownAction data-popconfirm-stay-open>
            <SvgIcon type="trash" width={14} />
            Delete
          </DropdownAction>
        </Popconfirm>
      </DropdownItem>
    </DropdownList>
  </DropdownContent>
);

NoteControl.propTypes = {
  _id: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
  openNoteModal: PropTypes.func.isRequired,
  handleNoteDelete: PropTypes.func.isRequired,
};


const Note = ({
  _id,
  text,
  date,
  users,
  contacts,
  feedbacks,
  createdBy,
  meetingInfo,
  participants,
  ...rest
}) => (
  <NoteWrap>
    <MeetingNote>
      <ReactQuillWrappedContainer>
        <ReactQuillWrapped theme={null} value={text} readOnly />
      </ReactQuillWrappedContainer>
      <DropdownWithDots
        overlay={NoteControl({
          _id, ...rest,
        })}
      />
    </MeetingNote>
    <NoteInfo>
      <Creator
        date={date}
        fullName={createdBy.fullName}
      />

      {meetingInfo && stripHtml(meetingInfo).trim().length > 0 && (
        <MeetingInfoWrapper>
          <MeetingInfo meetingInfo={meetingInfo} />
        </MeetingInfoWrapper>
      )}

      {getMeetingAverageRating(feedbacks) && (
        <RatePannelWrapper>
          <RatePannel rateValue={getMeetingAverageRating(feedbacks)} />
        </RatePannelWrapper>
      )}

      <ParticipantsWrap>
        <ParticipantsWithFeedbacks
          requestId={_id}
          users={users}
          contacts={contacts}
          feedbacks={feedbacks}
          participants={participants}
        />
      </ParticipantsWrap>
    </NoteInfo>
  </NoteWrap>
);

Note.propTypes = {
  _id: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  users: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  feedbacks: PropTypes.array.isRequired,
  createdBy: PropTypes.object.isRequired,
  participants: PropTypes.object.isRequired,
  meetingInfo: PropTypes.string,
};

Note.defaultProps = {
  meetingInfo: '',
};

export default Note;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/index.js